<script setup>
import { Link, useForm } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import BookingSubMenu from '@/Includes/BookingSubMenu.vue';
import { ref, onMounted } from "vue";
import { useToast } from 'vue-toast-notification';
import Loading from 'vue-loading-overlay';
import { Modal } from 'bootstrap';
import FlatPickr from 'vue-flatpickr-component';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css'
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

const props = defineProps({
    year: String,
    bookingClients: Object,
    bookingById: Object,
    flash: Object,
    card: Boolean,
    user: Object,
});

dayjs.extend(advancedFormat);
const $toast = useToast();
let isLoading = ref(false);
let modalShow = ref(null);
let thisModalObj = null;
let menu = 'clients';

const configDob = ref({
    altFormat: 'J M, Y',
    altInput: true,
    dateFormat: 'Y-m-d',
});

onMounted(() => {
    thisModalObj = new Modal(modalShow.value);

    const readonlyInput = document.querySelectorAll('input[readonly]');
    readonlyInput.forEach((item) => {
        item.style.backgroundColor = '#eceef14a';
    });
});

function getClientData(value) {
    axios.get("/bookings/getClientData/", {
        params: {
            client_id: value
        }
    }).then((response) => {
        if (response.data) {
            ClientEditform.client_id = response.data.id;
            ClientEditform.first_name = response.data.first_name;
            ClientEditform.last_name = response.data.last_name;
            ClientEditform.title = response.data.title;
            ClientEditform.dob = response.data.dob;
            ClientEditform.room_no = response.data.room_no;
            ClientEditform.booking_id = response.data.booking_id;
        }
    });
}

const ClientAddform = useForm({
    title: null,
    first_name: null,
    last_name: null,
    dob: null,
    room_no: null,
    booking_id: props.bookingById.id,
});

const ClientEditform = useForm({
    title: null,
    first_name: null,
    last_name: null,
    dob: null,
    room_no: null,
    booking_id: props.bookingById.id,
    client_id: null,
});

const ClientAddformSubmit = () => {
    ClientAddform.post('/bookings/clientstore', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide()
            $toast.open({
                message: props.flash.message,
                type: "info",
                duration: 4000,
                position: 'top-right',
                class: 'bs-toast toast bg-dark show'
            });
        }
    });
};

const ClientEditformSubmit = () => {
    ClientEditform.post('/bookings/clientupdate', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide()
            $toast.open({
                message: props.flash.message,
                type: "info",
                duration: 4000,
                position: 'top-right',
                class: 'bs-toast toast bg-dark show'
            });
        }
    });
};

function deleteClient(value) {
    new Swal({
        title: 'Are you sure?',
        text: "All the data related to this client will be deleted!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'I am sure!'
    }).then((result) => {
        if (result.isConfirmed) {
            setTimeout(() => {
                window.location.href = '/bookings/deleteclient/' + value;
            }, 300);

            $toast.success('Client deleted successfully!', {
                position: 'top-right',
                duration: 4000,
                hideProgressBar: true,
                icon: true,
                type: "info",
                class: 'bs-toast toast bg-dark show'
            });
        }
    })
}

function FormReset() {
    ClientAddform.reset();
    ClientAddform.clearErrors();
    ClientEditform.reset();
    thisModalObj.hide();
}
</script>
<style scoped>
@import "../../../../public/ui/vendor/libs/toastr/toastr.css";
@import 'flatpickr/dist/themes/material_orange.css';
</style>
<template>
    <AppLayout title="Hotel Manager" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <BookingSubMenu :bookingById="bookingById" :menu="menu" />
            <div class="card">
                <div class="card-datatable table-responsive">
                    <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper dt-bootstrap5 no-footer">
                        <div class="card-header flex-column flex-md-row">
                            <div class="head-label text-center">
                                <h5 class="card-title mb-0">Clients</h5>
                            </div>
                        </div>

                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Date of birth</th>
                                    <th>Room No</th>
                                    <th>Type</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody class="table-border-bottom-0">
                                <tr v-for="clients in bookingClients.client" :key="clients.id">
                                    <td><i class="fab fa-angular fa-lg text-danger me-3"></i> <strong>{{
                                        clients.title
                                    }}</strong></td>
                                    <td>{{ clients.first_name }}</td>
                                    <td>
                                        {{ clients.last_name }}
                                    </td>
                                    <td v-if="clients.dob">
                                        {{ dayjs(clients.dob).format('Do MMM YYYY') }}
                                    </td>
                                    <td v-else>
                                    </td>
                                    <td>{{ clients.room_no }}</td>
                                    <td v-if="clients.dob"> Child</td>
                                    <td v-else>Adult</td>
                                    <td>
                                        <div class="dropdown" v-if="bookingById.status !== 'Cancelled'">
                                            <button type="button" class="btn p-0 dropdown-toggle hide-arrow"
                                                data-bs-toggle="dropdown">
                                                <i class="bx bx-dots-vertical-rounded"></i>
                                            </button>
                                            <div class="dropdown-menu">
                                                <Link class="dropdown-item" data-bs-toggle="modal" href="#"
                                                    v-if="$page.props.user.permissions.includes('edit-booking-clients')"
                                                    data-bs-target="#editclientModal"
                                                    @click="getClientData(clients.id)">
                                                <i class="bx bx-edit-alt me-1"></i>
                                                Edit</Link>
                                                <Link class="dropdown-item" @click="deleteClient(clients.id)" href="#"
                                                    v-if="$page.props.user.permissions.includes('remove-booking-clients')"
                                                    preserveScroll><i class="bx bx-trash me-1"></i> Delete</Link>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="addClientModal" tabindex="-1" aria-modal="true" role="dialog" ref="modalShow">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add Client</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <hr>
                    <form @submit.prevent="ClientAddformSubmit">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-2">
                                    <label for="title" class="form-label"><b>Title</b></label>
                                    <select v-model="ClientAddform.title" class="form-select" name="title"
                                        required="required">
                                        <option value="" selected="selected" disabled="disabled">Select Title</option>
                                        <option value="Mr">Mr</option>
                                        <option value="Mrs">Mrs</option>
                                        <option value="Ms">Ms</option>
                                        <option value="Dr">Dr</option>
                                    </select>
                                </div>
                                <div class="col-md-5">
                                    <label for="first_name" class="form-label"><b>First Name</b></label>
                                    <input type="text" v-model="ClientAddform.first_name" name="first_name"
                                        class="form-control" placeholder="First Name" required="required">
                                </div>
                                <div class="col-md-5">
                                    <label for="last_name" class="form-label"><b>Last Name</b></label>
                                    <input type="text" v-model="ClientAddform.last_name" name="last_name"
                                        class="form-control" placeholder="Last Name" required="required">
                                </div>
                                <div>
                                    <hr>
                                </div>
                                <div class="col-md-4">
                                    <label for="dob" class="form-label"><b>DOB</b></label>
                                    <FlatPickr v-model="ClientAddform.dob" :config="configDob" class="form-control"
                                        placeholder="Date of birth" name="dob" required="required" />
                                </div>
                                <div class="col-md-4">
                                    <label for="room_no" class="form-label"><b>Room</b></label>
                                    <select class="form-select" v-model="ClientAddform.room_no" name="room_no"
                                        required="required">
                                        <option value="" selected="selected" disabled="disabled">Select Room</option>
                                        <option v-for="norooms in bookingById.no_rooms" :value="norooms">{{ norooms }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-label-secondary" @click="FormReset">
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">Add Client</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal fade" id="editclientModal" tabindex="-1" aria-modal="true" role="dialog" ref="modalShow">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit Client</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <hr>
                    <form @submit.prevent="ClientEditformSubmit">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-2">
                                    <label for="title" class="form-label"><b>Title</b></label>
                                    <select v-model="ClientEditform.title" class="form-select" name="title"
                                        required="required">
                                        <option value="" selected="selected" disabled="disabled">Select Title</option>
                                        <option value="Mr">Mr</option>
                                        <option value="Mrs">Mrs</option>
                                        <option value="Ms">Ms</option>
                                        <option value="Dr">Dr</option>
                                    </select>
                                </div>
                                <div class="col-md-5">
                                    <label for="first_name" class="form-label"><b>First Name</b></label>
                                    <input type="text" v-model="ClientEditform.first_name" name="first_name"
                                        class="form-control" placeholder="First Name" required="required">
                                </div>
                                <div class="col-md-5">
                                    <label for="last_name" class="form-label"><b>Last Name</b></label>
                                    <input type="text" v-model="ClientEditform.last_name" name="last_name"
                                        class="form-control" placeholder="Last Name" required="required">
                                </div>
                                <div>
                                    <hr>
                                </div>
                                <div class="col-md-4">
                                    <label for="dob" class="form-label"><b>DOB</b></label>
                                    <FlatPickr v-model="ClientEditform.dob" :config="configDob" class="form-control"
                                        placeholder="Date of birth" name="dob" required="required" />
                                </div>
                                <div class="col-md-4">
                                    <label for="room_no" class="form-label"><b>Room</b></label>
                                    <select class="form-select" v-model="ClientEditform.room_no" name="room_no"
                                        required="required">
                                        <option value="" selected="selected" disabled="disabled">Select Room</option>
                                        <option v-for="norooms in bookingById.no_rooms" :value="norooms">{{ norooms }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-label-secondary" @click="FormReset">
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">Update Client</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </AppLayout>
</template>